module.exports = __WEBPACK_EXTERNAL_MODULE_810__;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = 810
// module chunks = 9